import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import {Link, useNavigate, useParams} from "react-router-dom";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import {SGP} from "./Competition/sgp-results-react";
import {Alert, Autocomplete, CircularProgress, Stack} from "@mui/material";
import TextField from "@mui/material/TextField";
import {KeyboardArrowRight} from "@mui/icons-material";
import Button from "@mui/material/Button";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment-timezone";
import {countryArray, eventStatus, getRlPilot} from "../util/standards-util";
import {
    useCreateCompetitionRegistrationMutation,
    useGetEventForRegistrationQuery,
    useLazyPreauthQuery
} from "../slices/apiSlice";
import Register, {isEmail} from "../components/Register";
import Login from "../components/Login";
import {useSelector} from "react-redux";
import {AUTHENTICATED} from "../slices/sessionSlice";
import AlertDialog from "../components/AlertDialog";
import ConfirmationDialog from "../components/ConfirmationDialog";


const EventRegistration = () => {
    let cnt = 0

    const navigate = useNavigate()
    const session = useSelector(state => state.session)
    const {eventId: eventIdParam} = useParams()

    const [step, setStep] = React.useState('email')
    const [country, setCountry] = React.useState('')
    const [dates, setDates] = React.useState('')
    const [email, setEmail] = React.useState()
    const [validationErrors,setValidationErrors] = React.useState()
    const [hasActiveUserV2,setHasActiveUserV2] = React.useState()
    const [existingUsernames,setExistingUsernames] = React.useState()
    const [rlId,setRlId] = React.useState()
    const [rlData,setRlData] = React.useState()
    const [username,setUsername] = React.useState()
    const [alert, setAlert] = React.useState()
    const [rlConfirm, setRlConfirm] = React.useState(false)
    const [rlInfoBody, setRlInfoBody] = React.useState()
    const [rlRank, setRlRank] = React.useState()
    const [isRegistrationOpen, setIsRegistrationOpen] = React.useState()


    const eventId = parseInt(eventIdParam) ?? 0
    const showList = eventIdParam === undefined

    const {data: comp, isSuccess: isCompSuccess } =
        useGetEventForRegistrationQuery(eventId)

    const [preauth, preauthResult]  =
        useLazyPreauthQuery()

    const [competitionRegister, competitionRegisterResults] =
        useCreateCompetitionRegistrationMutation()

    const handleErrorClose = () => {
        navigate('/')
    }

    const handleRlInfoClose = (confirm) => {
        setRlConfirm(false)
        if (confirm) {
            //TODO: assign entry values
            setRlRank(rlData.rankingpos)
        }
        else {
            setRlId()
            setRlData()
            //TODO: focus on RLId
        }
    }

    const handleCountryChange = (e, value) => {
        const country = value?.key
        setCountry(country)
    }

    const handleRlNumberChange = (e) => {
        const  val = e.target.value
        if (rlId !== val) {
            setRlId(val)
            if (Number(val) > 0) {
                getRlPilot(val,(data) => {
                    setRlData(data.data)
                    console.log(data.data)
                    setRlInfoBody(`name = ${data.data.firstname} ${data.data.surname}`)
                    setRlConfirm(true)
                })
            }
        }

    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);

        const errors = []

        if (step === 'email') {
            const email = formData.get('email')

            if (!isEmail(email)) errors.push('Please enter a valid email')

            if (errors.length === 0 ) {
                setEmail(email)
                setStep('preauth')
                preauth({email:email})
            }
        }

        if (step === "rlnumber") {
            var rlId = formData.get('igcRankingId')
            if (rlId) {
                setRlId(rlId)
                getRlPilot(rlId,(data) => {
                    setRlData(data)
                    console.log(data)
                })
            }
            setStep('application')
        }

        if (step === "application") {
            if (formData.get('igcRankingId') && isNaN(Number(formData.get('igcRankingId')))) {
                errors.push('The IGC Ranking List ID you have provided is of incorrect format. Please enter a valid ID or leave this field blank for now')
            }
            else if (formData.get("agreeCheck")) {
                const req = {
                    eventId: eventId,
                    details: {
                        igcRankingId: formData.get('igcRankingId'),
                        phone: formData.get('phone'),
                        address1: formData.get('address1'),
                        address2: formData.get('address2'),
                        city: formData.get('city'),
                        zipcode: formData.get('zipcode'),
                        region: formData.get('region'),
                        country: country,
                        gliderDescription: formData.get('gliderDescription'),
                        compId: formData.get('compId'),
                        sailplaneRegistration: formData.get('sailplaneRegistration'),
                        primaryLoggerSerial: formData.get('primaryLoggerSerial'),
                        secondaryLoggerSerial: formData.get('secondaryLoggerSerial'),
                        flarmId: formData.get('flarmId'),
                        competitionPhone: formData.get('competitionPhone'),
                        crewName: formData.get('crewName'),
                        crewPhone: formData.get('crewPhone'),
                        crewCompetitionPhone: formData.get('crewCompetitionPhone'),
                        crewEmail: formData.get('crewEmail'),
                    }
                }

                if (rlRank) req.rlRanking = rlRank

                competitionRegister(req)
            }
            else {
                errors.push('Please agree to the terms of the competition by clicking the checkbox')
            }
        }

        if (errors.length === 0 ) {
            setValidationErrors([])
        }
        else {
            setValidationErrors(errors)
        }
    }

    const handlePickUsername = (username) => {
        setUsername(username)
        setStep('login')
    }

    useEffect(() => {
        if (competitionRegisterResults.isSuccess) {
            if (competitionRegisterResults.data.status === 'ok') {
                navigate('/myEvents')
            }
            else {
                console.log('** Error with competition registration')
                console.log(competitionRegisterResults.data.error)
                setAlert(competitionRegisterResults.data.error)
            }
        }
        else if (competitionRegisterResults.error) {
            console.log('** Error with competition registration call')
            console.log(competitionRegisterResults.error)
            setAlert(competitionRegisterResults.error)
        }

    }, [competitionRegisterResults]);


    useEffect(() => {
        if (isCompSuccess) {
            if (comp.status === eventStatus.STATUS_PLANNED) setIsRegistrationOpen(true)

            if (moment(comp.firstDate).year() === moment(comp.lastDate).year()) {
                if (moment(comp.firstDate).month() === moment(comp.lastDate).month()) {
                    setDates(`${moment(comp.firstDate).format('D')} - ${moment(comp.lastDate).format('D MMMM yyyy')}`)
                }
                else {
                    setDates(`${moment(comp.firstDate).format('D MMMM')} - ${moment(comp.lastDate).format('D MMMM yyyy')}`)
                }
            }
            else {
                setDates(`${moment(comp.firstDate).format('D MMMM yyyy')} - ${moment(comp.lastDate).format('D MMMM yyyy')}`)
            }
        }
    }, [isCompSuccess]);


    useEffect(()=>{
        if (preauthResult.isSuccess) {
            const un = preauthResult.data.usernames
            if (un && un.length > 0 ) {
                //There exists at least one account with this email so give option to log in
                setExistingUsernames(un)
                const hasActiveUserV2 = un.find( u => u === email)!==undefined
                setHasActiveUserV2(hasActiveUserV2)

                if (hasActiveUserV2 || un.length === 1) {
                    //login
                    setUsername( hasActiveUserV2 ?  un.find( u => u === email) : un[0])
                    setStep('login')
                }
                else {
                    //choose username
                    setStep('chooseUsername')
                }
            }
            else {
                //there is no existing account under this email so continue with registration
                setExistingUsernames([])
                setStep('register')
            }
        }
    },[preauthResult])

    useEffect(()=>{
        if (session.status === AUTHENTICATED ) {
            setStep('application')
        }
    },[session.status])
    
    return (
        <Container>
            {isCompSuccess && <>
            <Box sx={{textAlign:'left',bgcolor:'#113248',color:'#ffffff'}} my={4} p={2}>
                <Stack direction={'row'}>
                    <Box mr={'24px'}>
                        <img src='/etc/img/sgp-series-logo-v3.png' alt="SGP" style={{width:'160px'}}/>
                    </Box>
                    <Box>
                        <Typography variant={'h5'}>{SGP.getChampionshipTitle(comp)}</Typography>
                        <Typography variant={'h5'}>{comp.fullEditionTitle}</Typography>
                        <Typography variant={'h6'}>{comp.venue}</Typography>
                        <Typography variant={'h6'}>{dates}</Typography>
                    </Box>
                </Stack>
            </Box>
            <Box sx={{textAlign:'center',maxWidth:'26rem',minWidth:'300px',marginX:'auto'}}>
                <Typography variant={'h3'} component={'div'} sx={{fontSize:'2rem'}}>
                    Competitor entry form
                </Typography>
                { step !== 'login' && step !== 'register' &&
                <Box component="form" onSubmit={handleSubmit} noValidate
                     sx={{
                         p:'1.5em 1.5em',
                     }}>

                    <Stack spacing={3}>
                        { step === 'preauth' && <>
                            <Typography variant={"body1"}>Working ...</Typography>
                            <Box sx={{textAlign:'center'}}><CircularProgress my={3}/></Box>

                        </>}
                        { step === 'email' && <>
                            <Typography variant={"body1"}>
                                To register for the event, please enter your email
                            </Typography>
                            <TextField variant='outlined' id="email" name="email" label="Email" defaultValue={''} />

                        </>}
                        {step === 'chooseUsername' && <>
                            <Box>
                                <Typography variant={"body1"} mb={2}  sx={{textAlign:'left'}}>
                                    You have more than one account at crosscountry.aero.
                                    Please choose the username you would like to use to continue
                                </Typography>
                                <Stack spacing={2} mt={4}>
                                    {existingUsernames.map(u => <Box sx={{cursor:'pointer',width:'100%',p:'12px',background:'#dddddd',borderRadius:'0.5em'}} onClick={()=>{handlePickUsername(u)}}>{u}</Box>)}
                                </Stack>
                            </Box>
                        </>}
                        {step === 'application' && !isRegistrationOpen &&
                            <Box my={4}>
                                <Alert severity={'warning'}>Registration for this event is now closed</Alert>
                            </Box>}
                        {step === 'application' && isRegistrationOpen && <>
                            <Typography variant={'body2'} sx={{textAlign:'left',fontStyle:'italic'}}>
                                Please fill as much information as known at this time. You will be able to complete unknown information at a later date.
                            </Typography>

                            <Typography variant={'h6'} component={'div'}>
                                Sporting info
                            </Typography>
                            <TextField variant='outlined' id="igcRankingId" onBlur={handleRlNumberChange} name="igcRankingId" label="IGC Ranking List ID"  />

                            <Typography variant={'h6'} component={'div'}>
                                Contact details
                            </Typography>

                            <TextField variant='outlined' id="phone" name="phone" label="Mobile number"  defaultValue={''} />

                            <Box sx={{display:'flex',flexDirection:'column',alignItems:'stretch',rowGap:'.5em'}}>
                                <TextField variant='outlined' id="address1" name="address1" label="Street address"  />
                                <TextField variant='outlined' id="address2" name="address2" label="Street address 2" />
                                <TextField variant='outlined' id="city" name="city" label="City"  />
                                <TextField variant='outlined' id="zipcode" name="zipcode" label="Postal code"  />
                                <TextField variant='outlined' id="region" name="region" label="State / Province / Region"/>
                                <Autocomplete
                                    disablePortal
                                    selectOnFocus
                                    clearOnBlur
                                    handleHomeEndKeys
                                    id="country"
                                    name="country"
                                    options={countryArray}
                                    renderInput={(params) => <TextField {...params}  label="Country" />}
                                    onChange={handleCountryChange}
                                />
                            </Box>

                            <Typography variant={'h6'} component={'div'}>
                                Sailplane info
                            </Typography>
                            <TextField variant='outlined' id="gliderDescription" name="gliderDescription" label="Sailplane type" />
                            <TextField variant='outlined' id="compId" name="compId" label="Sailplane competition ID"  />
                            <TextField variant='outlined' id="sailplaneRegistration" name="sailplaneRegistration" label="Sailplane registration"  />



                            <Typography variant={'h6'} component={'div'}>
                                Logger & tracking info
                            </Typography>

                            <TextField variant='outlined' id="primaryLoggerSerial" name="primaryLoggerSerial" label="Primary logger serial number"  defaultValue={''} />
                            <TextField variant='outlined' id="secondaryLoggerSerial" name="secondaryLoggerSerial" label="Secondary logger serial number"  defaultValue={''} />
                            <TextField variant='outlined' id="flarmId" name="flarmId" label="Flarm ID"  defaultValue={''} />

                            <Typography variant={'h6'} component={'div'}>
                                Contact info during competition
                            </Typography>

                            <TextField variant='outlined' id="competitionPhone" name="competitionPhone" label="Mobile number during competition (if different)"  defaultValue={''} />
                            <TextField variant='outlined' id="crewName" name="crewName" label="Crew name"  defaultValue={''} />
                            <TextField variant='outlined' id="crewPhone" name="crewPhone" label="Crew mobile number"  defaultValue={''} />
                            <TextField variant='outlined' id="crewCompetitionPhone" name="crewCompetitionPhone" label="Crew secondary mobile number"  defaultValue={''} />
                            <TextField variant='outlined' id="crewEmail" name="crewEmail" label="Crew email"  defaultValue={''} />
                            <Box component='div'
                                 sx={{
                                     textAlign: 'left',
                                     mt:'1em',
                                 }}
                            >
                                <FormControlLabel control={<Checkbox id={'agreeCheck'} name={'agreeCheck'}/>} size={'small'}
                                                  label={<Typography variant={'body2'} component={'div'} sx={{textAlign: 'left', fontSize:'.82em'}}>I agree with the competition terms & regulations</Typography>}
                                />
                            </Box>
                        </>}
                        <Box>
                            {validationErrors &&
                                validationErrors.map( err =>{
                                    return (
                                        <Alert  key={++cnt} severity="error" sx={{margin: '0.5em 0 1em 0'}}>
                                            {err}
                                        </Alert>
                                    )
                                })
                            }
                            { step !== 'login' && isRegistrationOpen &&
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    endIcon={step === "application" ? undefined : <KeyboardArrowRight/>}
                                    sx={{ mt: 2, mb: 2 }}
                                >
                                    {step === "application" ?  'Submit entry' : 'Next'}
                                </Button>
                            }
                        </Box>
                        <Stack>
                            <Box sx={{display:'flex',alignItems:'center',justifyContent:'center'}}>
                                <Typography variant={'body2'} mr={1}>Powered by</Typography>
                                <a href='https://www.crosscountry.aero' target="_blank" style={{display:'inline-flex',marginBottom:'-2px'}}><img src={'/etc/img/cc-logo-v3-black.png'} style={{width:'8em'}}/></a>
                            </Box>
                            <Typography variant={'body2'} sx={{fontSize:'.85em',mt:'.25em',color:'#666666'}}>SGP OFFICIAL SCORING PARTNER</Typography>
                        </Stack>
                    </Stack>
                    </Box>
                }
                {step === 'login' &&
                    <Box my={3}>
                        <Typography variant={"body1"}>
                            You already have an account at crosscountry.aero. Please sign in to continue
                        </Typography>
                        <Login prefillEmail={username} showRedressPaths={false} headerText={false} forgotPasswordAction={`/eventRegistration/${eventIdParam}`}/>
                    </Box>
                }
                {step === 'register' && <>
                    <Typography variant={"body1"} sx={{fontStyle:'italic'}} mt={2}>
                        Step 1 - Create an account with crosscountry.aero
                    </Typography>
                    <Register standalone={false} email={email}/>
                </>}
                {alert &&
                    <AlertDialog title={'Registration error'} body={alert} onClose={handleErrorClose}/>
                }
                {rlConfirm &&
                    <ConfirmationDialog title={'Ranking List information'} body={
                        <>
                            <Box>The IGC Ranking List ID you provided has the following information:</Box>
                            <Box my={4}><TextField variant='outlined' label='Pilot name' value={`${rlData?.firstname} ${rlData?.surname}`}/></Box>
                            <Box>Please confirm that this information matches your details</Box>
                        </>
                    } onCancel={() => handleRlInfoClose(false)} onConfirm={() => {handleRlInfoClose(true)}} confirmText='This is me'/>
                }
            </Box>
            </>}
        </Container>
    );
};

export default EventRegistration;